// extracted by mini-css-extract-plugin
export default {"SignUpPage":"SignUp_SignUpPage__18yjm","SignUpPage__body":"SignUp_SignUpPage__body__38pZF","SignUpPage__navbar":"SignUp_SignUpPage__navbar__3sd1g"};